import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Users } from '../users.model';
import { UsersService } from '../users.service';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { sortBy, get, lowerCase, map, chain, unescape } from 'lodash';
import { AppRoutingService } from '../../app-routing.service';
import { Encoder } from '../../../utils/encoder';
import { UsersListResponse } from '../users-list-reponse.model';

@Component({
  selector: 'app-users-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class UsersListComponent implements OnInit {

  alerts: any = {
    newUsersAdded: {
      show: false,
      type: 'success',
      msg: 'Users registered successfully'
    },
    usersUpdated: {
      show: false,
      type: 'success',
      msg: 'Users updated successfully'
    },
    error: {
      show: false,
      type: 'danger',
      msg: 'An error occurred'
    }
  };

  showAlert: boolean;

  usersList: Array<Users>;

  usersListResponse: UsersListResponse;

  constructor(private router: Router, private route: ActivatedRoute,
    private usersService: UsersService, private routingService: AppRoutingService) {

    this.usersList = new Array<Users>();
    this.showAlert = false;
  }

  ngOnInit() {
    this.alerts.newUsersAdded.show = this.usersService.hasJustRegistered;
    this.alerts.usersUpdated.show = this.usersService.hasJustUpdated;

    this.usersService.hasJustRegistered = false;
    this.usersService.hasJustUpdated = false;
    this.getUsersList();
  }

  onClosed(dismissedAlert: any): void {
    dismissedAlert.show = false;
  }


  private getUsersList(): void {

    const data = this.route.snapshot.data;
    this.usersListResponse = get(data, ['users'], []);
    this.usersList = this.usersListResponse.data;
    if (this.usersList.length === 0) {
      this.showAlert = true;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/users/list/list.component.ts